<template>
  <div>
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="pb-8">
        <v-container>
          <v-text-field
            v-model="form.Title"
            single-line
            label="Title"
            required
          ></v-text-field>
          <vue-editor useCustomImageHandler v-model="form.Content"></vue-editor>
          <v-row>
            <v-col cols="12" md="12"
              ><v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="publishdate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.PublishDate"
                    label="Publish date"
                    append-icon="mdi-calendar-range-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="form.PublishDate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu1 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu1.save(publishdate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu></v-col
            >
          </v-row>
          <v-select
            v-model="form.ShowTo"
            multiple
            :items="getMembership"
            item-text="Name"
            item-value="Id"
            single-line
            label="Show to: (Instructors, All members, practitioners, etc)"
            required
          ></v-select>
        </v-container>
      </v-form>
    </v-card>
    <v-card-actions class="pb-4 mx-4 py-8">
      <v-spacer></v-spacer>
      <v-btn
        class="px-14 py-6 mb-2"
        color="grey lighten-1"
        style="text-transform: none"
        text
        @click="close"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        style="text-transform: none"
        class="px-14 py-6 mb-2"
        @click="send()"
      >
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-if="btnloader"
        ></v-progress-circular>
        <span class="pa-4" v-else> Save </span>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
export default {
  name: "AddAdvertsComponent",
  computed: {
    ...mapGetters(["getMembership", "GetLoggedInUser"]),
  },
  props: ["editItem"],
  components: { VueEditor },
  mounted() {
    if (this.editItem != undefined) {
      this.form = {
        Id: this.editItem.Id,
        Title: this.editItem.Title,
        Content: this.editItem.Content,
        PublishDate:
          this.editItem.PublishDate != null
            ? this.editItem.PublishDate.split("T")[0]
            : "",
        ShowTo:
          this.editItem.Showto != ""
            ? this.editItem.Showto.split(",").map((x) => parseInt(x))
            : [],
      }; 
    }
    this.form.CreatedBy = this.GetLoggedInUser.Id;
    this.$store.dispatch("getMembership") 
  },
  methods: {
    close() {
      this.$emit("close");
    },
    send() {
      this.btnloader = true; 
      if (this.form.ShowTo.length > 0) {
        this.form.ShowTo = this.form.ShowTo.join(",");
      } else {
        this.form.ShowTo = "";
      }
      if (this.form.Id == 0) {
        this.$store.dispatch("PostAnnouncement", this.form).then((res) => {
          if (res.Status) {
            this.btnloader = false;
            this.form = {
              Id: 0,
              Title: "",
              Content: "",
              PublishDate: null,
              ShowTo: [],
              CreatedBy: "",
            };
            this.close();
          } else {
            this.btnloader = false;
          }
        });
      } else { 

        this.$store.dispatch("EditAnnouncement", this.form).then((res) => {
          if (res.Status) {
            this.btnloader = false;
            this.form = {
              Id: 0,
              Title: "",
              Content: "",
              PublishDate: null,
              ShowTo: [],
              CreatedBy: "",
            };
            this.close();
          } else {
            this.btnloader = false;
          }
        });
      }
    },
  },
  data() {
    return {
      title: "",
      url: "",
      publishdate: "",
      enddate: "",
      ShowTo: "",
      form: {
        Id: 0,
        Title: "",
        Content: "",
        PublishDate: null,
        ShowTo: [],
        CreatedBy: "",
      },
      btnloader: false,
      //   date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      //     .toISOString()
      //     .substr(0, 10),
      menu1: false,
      menu2: false,
    };
  },
};
</script>

<style scoped>
.spanOne {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 400;
}
.spanTwo {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;
}
.spanThree {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
}
.spanthree_one {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  color: #b2b3bb;
}
</style>
